import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { HOME_BOARD } from './constants';
import { Box, Spinner } from '@chakra-ui/react';
import { customColors } from '../theme';

interface NoHautRouteProps {
  children: ReactNode;
}

const NoHautRoute: React.FC<NoHautRouteProps> = ({ children }) => {
  const { user, isAppLoading } = useAppContext();

  if (isAppLoading) {
    return (
      <Box w="100vw" bgColor={customColors.blackTegrite} h="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="xl" color={customColors.yellowBob} />
      </Box>
    );
  }

  return !user ? <>{children}</> : <Navigate to={HOME_BOARD} />;
};

export default NoHautRoute;
